import './UploadFile.css';

import React, { useEffect, useState } from 'react';
import MimeIcon from './MimeIcon';
import CustomButton from '../../../b2b-common/CustomButton';
import { Search } from '@mui/icons-material';
import FieldText from '../../../b2b-common/FieldText';
import useB2BTranslation from '../../../b2b-common/hooks/useB2BTranslation';

const truncateFileName = (fileName, charLimit) => {
    const extensionIndex = fileName.lastIndexOf('.');
    if (extensionIndex === -1) return fileName; // No extension found

    const baseName = fileName.substring(0, extensionIndex);
    const extension = fileName.substring(extensionIndex);

    if (baseName.length <= charLimit) {
        return fileName;
    }

    const truncatedBaseName = baseName.substring(0, charLimit) + '...';
    return truncatedBaseName + extension;
};

const UploadFile = ({ itemFile = null, onFileChange }) => {
    const { t } = useB2BTranslation('b2b-logbook');
    const [selectedFile, setSelectedFile] = useState(itemFile);
    const [fileName, setFileName] = useState(null);
    const [mimeType, setMimeType] = useState(null);

    useEffect(() => {
        setSelectedFile(itemFile);
        if (itemFile) {
            setMimeType(itemFile.logBookItemFileMime);
            setFileName(itemFile.logBookItemFileName);
        }
    }, [itemFile]);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setFileName(file.name);
        setMimeType(file.type);
        onFileChange && onFileChange(file);
    }

    const handleButtonClick = () => {
        document.getElementById('fileInput').click();
    }

    return (
        <div className='upload-file-container'>
            <input
                type='file'
                id='fileInput'
                className='upload-file-input'
                onChange={handleFileChange}
                style={{ display: 'none' }}
            />
            <div className='upload-file-info'>
                {mimeType && (
                    <div className='upload-file-mime'>
                        <MimeIcon mime={mimeType} />
                    </div>
                )}
                <FieldText
                    label={t('File Name')}
                    text={fileName ? truncateFileName(fileName, 30) : t('No file selected')}
                    labelAlign='left'
                    className={'upload-file-name'}
                />
            </div>
            <CustomButton icon={<Search />} tooltip={t('Select File')} onClick={handleButtonClick} theme={'white_01'} />
        </div>
    );
}

export default UploadFile;